__webpack_require__.p = "https://bundle.stayforlong.com/20251204.4/_next/";